/**
 * Manahia — panneaux "Je choisis un cadeau pour une personne / pour une
 * occasion" (v5, 2026-10-09 — remplace l'ancien bandeau en ronds/vignettes)
 *
 * Les 3 filtres (Destinataire, Occasion, Intention) sont maintenant de vrais
 * <select> à sélection unique, chacun synchronisé avec son propre jeu de
 * cases à cocher réelles (invisibles) que Shopify sait interpréter dans
 * l'URL de filtrage :
 *   - choisir une option coche sa case et décoche les autres du même
 *     filtre (un seul choix actif à la fois) ;
 *   - revenir à l'option vide décoche tout (aucune valeur active).
 *
 * Règle demandée par Juana : les panneaux "Pour qui ?" (Destinataire) et
 * "Pour quelle occasion ?" (Occasion) sont mutuellement exclusifs — choisir
 * l'un efface automatiquement l'autre. Intention n'est concernée par aucune
 * exclusivité et peut se combiner librement avec l'un OU l'autre.
 *
 * Intention apparaît deux fois (un sélecteur dans chaque panneau, demandé
 * par Juana) mais ne représente qu'UN SEUL filtre Shopify : les cases à
 * cocher des deux exemplaires partagent le même "name"/"value" (la 2ᵉ copie
 * n'est qu'un 2ᵉ point d'accès visuel au même filtre), donc la
 * synchronisation se fait sur l'ensemble du formulaire, pas seulement dans
 * le panneau où le changement a eu lieu.
 *
 * Un évènement "input" est ensuite déclenché sur le formulaire pour que
 * facet-filters-form (assets/facets.js, natif Dawn) lance la mise à jour
 * AJAX, exactement comme pour n'importe quelle autre case à cocher.
 *
 * Écouteur posé une seule fois, par délégation sur document : il survit
 * aux rafraîchissements AJAX de Dawn, qui remplacent le contenu interne
 * des panneaux (innerHTML) sans jamais recharger ce script.
 *
 * --- Correctif "options désactivées" (2026-10-09) -----------------------
 * Shopify calcule le "disabled" de chaque <option>/case Destinataire et
 * Occasion à partir des filtres ACTUELLEMENT cochés : si Destinataire:Couple
 * est coché, la quasi-totalité des occasions ont 0 produit EN COMBINAISON
 * avec Couple et sont donc rendues disabled (ex. observé : 11 occasions sur
 * 12 désactivées dès qu'une personne est sélectionnée). Mais notre règle
 * d'exclusivité mutuelle efface systématiquement l'autre filtre AVANT
 * d'envoyer la requête : cette combinaison "les deux à la fois" n'est donc
 * JAMAIS réellement demandée au serveur. Le disabled calculé pour elle est
 * trompeur et bloque à tort l'utilisateur : un champ HTML disabled n'est ni
 * cliquable, ni inclus dans les données du formulaire à l'envoi (FormData
 * les ignore), donc sélectionner une occasion disabled aboutissait à une
 * requête sans AUCUN filtre (les deux étaient perdus). On neutralise ce
 * calcul en réactivant systématiquement les <option> et cases de ces 2
 * filtres après chaque rendu (au chargement initial, et après chaque
 * rafraîchissement AJAX de Dawn, via un MutationObserver). Intention n'est
 * volontairement pas concernée : elle se combine réellement avec Destinataire
 * OU Occasion (pas d'exclusivité), donc son disabled reste exact.
 */
(function () {
  function syncCheckboxes(form, select, checkboxClass) {
    var checkboxes = form.querySelectorAll('.' + checkboxClass);
    checkboxes.forEach(function (checkbox) {
      checkbox.checked = checkbox.value === select.value;
    });
  }

  function clearCheckboxes(form, checkboxClass) {
    var checkboxes = form.querySelectorAll('.' + checkboxClass);
    checkboxes.forEach(function (checkbox) {
      checkbox.checked = false;
    });
  }

  function reenableOptions(selectEl, checkboxClass) {
    if (selectEl) {
      Array.prototype.forEach.call(selectEl.options, function (option) {
        option.disabled = false;
      });
    }
    document.querySelectorAll('.' + checkboxClass).forEach(function (checkbox) {
      checkbox.disabled = false;
    });
  }

  function reenableDestinataireAndOccasion() {
    reenableOptions(document.querySelector('.manahia-destinataire-select'), 'manahia-destinataire-checkbox');
    reenableOptions(document.querySelector('.manahia-occasion-select'), 'manahia-occasion-checkbox');
  }

  // Passage initial (chargement de page, y compris si l'URL contient déjà
  // un filtre actif) puis à chaque fois que Dawn réécrit le panneau en AJAX.
  reenableDestinataireAndOccasion();

  var panelsContainer = document.querySelector('.manahia-gift-panels');
  if (panelsContainer && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      reenableDestinataireAndOccasion();
    });
    // childList/subtree seulement : capte le remplacement de innerHTML fait
    // par Dawn (assets/facets.js, FacetFiltersForm.renderFilters) sans
    // observer les attributs — sinon notre propre "option.disabled = false"
    // ci-dessus redéclencherait l'observateur en boucle.
    observer.observe(panelsContainer, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (event) {
    var form = event.target.closest('#FacetFiltersForm');
    if (!form) return;

    var destinataireSelect = event.target.closest('.manahia-destinataire-select');
    var occasionSelect = event.target.closest('.manahia-occasion-select');
    var intentionSelect = event.target.closest('.manahia-intention-select');

    if (destinataireSelect) {
      syncCheckboxes(form, destinataireSelect, 'manahia-destinataire-checkbox');
      // Exclusivité demandée par Juana : choisir une personne efface
      // l'occasion choisie (les deux ne sont jamais actifs en même temps).
      if (destinataireSelect.value !== '') {
        clearCheckboxes(form, 'manahia-occasion-checkbox');
      }
    } else if (occasionSelect) {
      syncCheckboxes(form, occasionSelect, 'manahia-occasion-checkbox');
      if (occasionSelect.value !== '') {
        clearCheckboxes(form, 'manahia-destinataire-checkbox');
      }
    } else if (intentionSelect) {
      // Les cases à cocher Intention sont partagées par les 2 panneaux :
      // la synchronisation porte sur tout le formulaire, pas seulement
      // sur le panneau où le changement a eu lieu.
      syncCheckboxes(form, intentionSelect, 'manahia-intention-checkbox');
    } else {
      return;
    }

    form.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
